export default __webpack_public_path__ + "static/media/샴푸바 클래스_웹.6dbcaf0d.jpg";